import { ChangeEventHandler } from 'react';
import { Form } from 'react-bootstrap';
import './style.scss';

interface ICustomFormInputProps {
  placeholder?: string;
  feedback?: string;
  value?: string | string[] | number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  type?: string;
  required?: boolean;
  minLength?: number;
}

const CustomFormInput = ({ placeholder, feedback, ...formControlProps }: ICustomFormInputProps) => {
  return (
    <Form.Group className="custom-form-input form-group">
      <Form.Control placeholder="." {...formControlProps} />
      <span className="floating-label">{placeholder}</span>
      <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
    </Form.Group>
  );
};

export default CustomFormInput;
